export * from './BoutiqueDetailView';
